module.exports = __webpack_public_path__ + "img/borderRing3White.c32a3101.svg";